module.exports = ".form-control {\n  cursor: pointer;\n  padding-left: 44px; }\n\n.icon {\n  font-size: 1.4rem;\n  position: absolute;\n  top: -2px;\n  left: 14px; }\n\ninput[type=file] {\n  display: none; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/stadium-background/stadium-background.component.scss
// module id = ./src/app/shared/components/stadium-background/stadium-background.component.scss
// module chunks = main